<template>
  <a-date-picker class="ant-date-picker-custom" v-bind="$attrs" :style="pickerStyle"
    :popup-class-name="computedPopupClassName" :popup-style="computedPopupStyle">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"></slot>
    </template>
  </a-date-picker>
</template>

<script setup lang="ts">
import { computed, type CSSProperties } from 'vue'

interface Props {
  borderColor?: string
  todayBackgroundColor?: string
  popupClassName?: string
  popupStyle?: CSSProperties
}

const props = defineProps<Props>()

const pickerStyle = computed(() => ({
  '--ant-date-picker-custom-border-color': props.borderColor || '#C5C5D3'
}) as CSSProperties)

const computedPopupClassName = computed(() => {
  return ['ant-date-picker-custom-popup', props.popupClassName].filter(Boolean).join(' ')
})

const computedPopupStyle = computed(() => ({
  ...props.popupStyle,
  '--ant-date-picker-custom-today-background-color': props.todayBackgroundColor,
  '--ant-date-picker-custom-selected-background-color': '#319456'
}) as CSSProperties)

defineOptions({
  name: 'AntDatePicker',
  inheritAttrs: false
})
</script>

<style lang="less">
.ant-date-picker-custom.ant-picker-focused {
  // box-shadow: 0 0 0 2px rgba(49, 148, 86, 0.23);
}

.ant-date-picker-custom {
  border-color: var(--ant-date-picker-custom-border-color) !important;

  &:hover,
  &.ant-picker-focused {
    border-color: var(--ant-date-picker-custom-border-color) !important;
  }

  .ant-picker-input>input {
    // text-align: center;
  }
}

.ant-date-picker-custom-popup {
  .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
    color: #fff;
    border: 1px solid #319456;
  }

  .ant-picker-cell-in-view.ant-picker-cell-today:not(.ant-picker-cell-selected) {
    .ant-picker-cell-inner {
      background-color: var(--ant-date-picker-custom-today-background-color) !important;
    }
  }

  .ant-picker-cell-in-view.ant-picker-cell-selected {
    .ant-picker-cell-inner {
      background-color: var(--ant-date-picker-custom-selected-background-color) !important;
    }
  }
}

.ant-picker-today-btn {
  color: #319456 !important;
}
</style>
